import React from 'react';
import { useNavigate } from "react-router-dom";
import './Footer.css';

const Footer = () => {

  const navigate = useNavigate();
  
  const handleContactClick = () => {
    navigate('/contact'); 
  };

  const handleCartClick = () => {
    navigate('/cart'); 
  };

  const handleMyAccountClick = () => {
    navigate('/myaccount'); 
  };
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img src="/assets/logo_1.png" alt="Suyochi Robotics" className="logo" />
          <p className="tagline">Suyochi Robotics</p>
        </div>
        
        <div className="support-section">
          {/* <p className="timing">Got Questions? Call us between 9:15 AM to 6:15 PM Monday–Saturday</p> */}
          <div className="support-row">
            <img src="/assets/customer_call.png" alt="Support" className="support-icon" />
            <p className="support-text">for customer numbers <br/>
              <span>+91-7075633573</span>
            </p>
          </div>
        </div>

        {/* Social media accounts  */}
        
        <div className="social-icons">
          <i className="fab fa-facebook-f"></i>
          <i className="fab fa-instagram"></i>
          <i className="fab fa-twitter"></i>
          <i className="fab fa-linkedin"></i>
        </div>

        <div className="footer-links">
          <h4>Information</h4>
          <ul>
            <li>Track Your Order</li>
            <li>FAQs</li>
            <li>Videos</li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>My Account</h4>
          <ul>
            <li onClick={handleCartClick} style={{ cursor: 'pointer' }}>Cart</li>
            <li>Checkout</li>
            <li onClick={handleMyAccountClick} style={{ cursor: 'pointer' }}>My Account</li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Services</h4>
          <ul>
            <li onClick={handleContactClick} style={{ cursor: 'pointer' }}>Contact Us</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>©2025 suyochi.com. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

